export const formatDateToYYYYMMDD = (date: Date|string): string => {

  if (typeof date === 'string') {
    return date;
  }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  export const formatDateToDDMMYYYY = (date: string): string => {
  // Assumes input is 'yyyy-mm-dd'
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
};